export default {
  myFiles: 'My documents',
  newDocument: 'New document',
  brand: 'Brand',
  messages: 'Messages',
  news: 'News',
  contact: 'Contact',
  greetings: 'Hello',
  save: 'Save',
  delete: 'Delete',
  delete2: 'DELETE',
  yes: 'Yes',
  no: 'No',
  cancel: 'Cancel',
  edit: 'Edit',
  addArticle: 'Add article',
  editArticle: 'Edit article',
  categories: 'Categories',
  complaintsAndReturns: 'Complaints and returns',
  newRequest: 'New request',
  bonusProgramRules: 'Bonus program rules',
  addCategory: 'Add category',
  editCategory: 'Edit category',
  deleteCategory: 'Delete category',
  areYouSureYouWantToDeleteAddress: 'Are you sure you want to remove the selected address?',
  articles: 'Articles',
  controlPanel: 'Control panel',
  importArticles: 'Import articles',
  paymentTerms: 'Payment terms',
  deleteArticle: 'Delete article',
  addresses: 'Addresses',
  approvedDebt: 'Approved debt',
  currentDebt: 'Current debt',
  debtOutsideCurrency: 'Debt outside currency',
  ord: 'Ord',
  import: 'Import',
  onlineShopping: 'Online shopping',
  defaultAddress: 'The following addresses will be used by default on the checkout page.',
  notSetAnyAddressYet: 'You have not set any address yet.',
  myAccount2: 'My account',
  securityAndPrivacy: 'Security and privacy',
  deliveryAndPayment: 'Delivery and payment',
  cancel3: 'Cancel',
  termsOfService: 'Terms of service',
  youNeedHelp: 'You need help?',
  service: 'Service',
  followUsOnSocialMedia: 'Follow us on social media',
  myArticles: 'My products',
  faq: 'FAQ',
  howToRegister: 'How to register?',
  apply: 'Apply',
  finances: 'Finances',
  shoppingHelp: 'Shopping help',
  articleDetails: 'Article Details',
  viewFinances: 'View finances',
  days: 'days',
  articleDetailsInfo:
    'Add here the article description with all details and necessary information.',
  homePageTitle: 'Home',
  companies: 'Companies',
  addCompany: 'Add company',
  editCompany: 'Edit company',
  article: 'Article',
  updateAddress: 'Update address',
  chooseState: 'Choose state',
  countries: 'Countries',
  addCountry: 'Add country',
  editCountry: 'Edit country',
  towns: 'Towns',
  addTown: 'Add town',
  editTown: 'Edit town',
  state: 'State',
  banks: 'Banks',
  shoppingCarts: 'Shopping carts',
  addBank: 'Add bank',
  editBank: 'Edit bank',
  wishListIsEmpty: 'Wish list is empty',
  users: 'Users',
  addUser: 'Add user',
  products: 'products',
  editUser: 'Edit user',
  currencies: 'Currencies',
  editCurrency: 'Edit currency',
  addCurrency: 'Add currency',
  measurementUnits: 'Measurement units',
  addMeasurementUnit: 'Add measurement unit',
  totalWithoutTax: 'Total without tax',
  zipCode: 'Zip code',
  totalTax: 'Total tax',
  addVariation: 'Add variation',
  login: 'Login',
  logIn: 'Login',
  logout: 'Log out',
  countryDetails: 'Country details',
  countryDetailsInfo: 'Add here country details',
  townDetails: 'Town details',
  townDetailsInfo: 'Add here town details',
  details: 'Details',
  detailsInfo: 'Add details here',
  noRecords: 'No results with given parameters',
  resetFilters: 'Reset filters',
  userProfile: 'User profile',
  expressPosts: 'Express posts',
  addExpressPost: 'Add express post',
  editExpressPost: 'Update express post',
  deleteExpressPost: 'Delete express post',
  comingSoon: 'Coming soon',
  customerBankAccounts: 'Customer accounts',
  addCustomerBankAccount: 'Add customer account',
  editCustomerBankAccount: 'Update customer account',
  contactPerson: 'Contact person',
  serialNumber: 'Serial number',
  productCode: 'Product code',
  checkout: 'Checkout',
  download: 'Download',
  actions: 'Actions',
  folderIsEmpty: 'Your document folder is empty',
  goToCheckout: 'Go to checkout',
  choose: 'Choose',
  chooseOptions: 'Choose options',
  from: 'From',
  to: 'To',
  markAllAsRead: 'Mark all as read',
  profileDashboard: 'Dashboard',
  notFound: 'Page not found',
  accountDetails: 'Account details',
  orders: 'Orders',
  forgotPassword: 'Forgot password',
  enterYourEmailAddressBelowAndWellSendYouInstructions: 'Enter your email address below and we will send you reset instructions!',
  passwordRecovery: 'Password recovery',
  reset: 'Reset',
  remembered: 'Remembered',
  register: 'Register',
  itemAddedToCart: 'Item added to cart.',
  articlesOnSale: 'Articles on sale',
  addToCartSuccessMessage: 'You have just added an item <br/> to the cart: ',
  tabs: 'Tabs',
  addTab: 'Create tab',
  editTab: 'Update tab',
  addToCart: 'Add to cart',
  deleteTab: 'Delete tab',
  addToCart2: 'Add to cart',
  brands: 'Brands',
  tags: 'Tags',
  docDate: 'Doc date',
  addBrand: 'Add brand',
  editBrand: 'Update brand',
  deleteBrand: 'Delete brand',
  productSales: 'Product sales',
  addProductSale: 'Add product sale',
  editProductSale: 'Update product sale',
  interestsAreas: 'Interests areas',
  addInterestsArea: 'Add interests area',
  editInterestArea: 'Update interests area',
  deleteInterestsArea: 'Delete interests area',
  orderArticles: 'Order articles',
  rma: 'RMA',
  blog: 'Blog',
  blogs: 'Blogs',
  addBlog: 'Add blog',
  editBlog: 'Update blog',
  polls: 'Polls',
  addPoll: 'Add poll',
  editPoll: 'Update poll',
  terms: 'Terms and conditions',
  coupons: 'Coupons',
  myProfile: 'My profile',
  deleteSelected: 'Delete selected',
  areYouSureArticle: 'Are you sure you want to delete the article {article}?',
  areYouSureAttribute: 'Are you sure you want to delete the attribute {attribute}?',
  areYouSureAttributeArticle: 'Are you sure you want to delete the attribute?',
  areYouSureAttributeValue: 'Are you sure you want to delete the attribute value {attributeValue}?',
  areYouSureBank: 'Are you sure you want to delete the bank {bank}?',
  areYouSureBlog: 'Are you sure you want to delete the blog post {blog}?',
  areYouSureBrand: 'Are you sure you want to delete the brand {brand}?',
  areYouSureCategory: 'Are you sure you want to delete the category {category}?',
  areYouSureCompany: 'Are you sure you want to delete the company {company}?',
  areYouSureCountry: 'Are you sure you want to delete the country {country}?',
  areYouSureCurrency: 'Are you sure you want to delete the currency {currency}?',
  areYouSureCustomerBankAccount: 'Are you sure you want to delete the customer bank account {bankAccount}?',
  areYouSureExpressPost: 'Are you sure you want to delete the express post service {post}?',
  areYouSureInterestsArea: 'Are you sure you want to delete the industry area {area}?',
  areYouSureProductSale: 'Are you sure you want to delete the sale {productSale}?',
  areYouSureSelected: 'Are you sure you want to delete selected records?',
  selectAction: 'Choose action',
  noItemSelected: 'No item selected',
  areYouSureTab: 'Are you sure you want to delete the tab {tab}?',
  areYouSureTown: 'Are you sure you want to delete the town {town}?',
  areYouSureUser: 'Are you sure you want to delete the user {user}?',
  areYouSureCancelOrder: 'Are you sure you want to cancel the order?',
  areYouSureApproveOrder: 'Are you sure you want to approve the order?',
  attributes: 'Attributes',
  allRightsReserved: 'All rights reserved',
  addAttribute: 'Add attribute',
  editAttribute: 'Update attribute',
  deleteAttribute: 'Delete attribute',
  areasOfInterest: 'Areas of interest',
  cancel2: 'CANCEL',
  chooseAreaOfInterest: 'Choose area of interest',
  oldPassword: 'Old password',
  sendRequest: 'SEND REQUEST',
  deleteUserAcc: 'DELETE USER ACCOUNT',
  permanentlyDeletedAcc: 'The user account will be permanently deleted',
  myAccount: 'My profile',
  shoppingCart: 'Shopping cart',
  wishlist: 'Wishlist',
  newPassword: 'New password',
  warning: 'Warning',
  areYouSureYouWantToDeleteAcc: 'Are you sure you want to delete your account? Please enter your password to delete your account.',
  attention: 'Attention',
  passwordConfirmation: 'Password confirmation',
  confirmNewPassword: 'Confirm new password',
  changePassword: 'Change password',
  currentPassLeaveBlank: 'Current password (leave blank if you do not want to change it)',
  newPassLeaveBlank: 'New password (leave blank if you do not want to change it)',
  search: 'Search',
  find: 'Find...',
  showMore: 'Show more',
  reviews: 'Review',
  comment: 'Comment',
  claims: 'Claims',
  bookingDateShort: 'Booking date',
  account: 'Account',
  paymentTerm: 'Payment term',
  accountNumber: 'Account number',
  owes: 'Owes',
  productIsAvalible: 'The product is available',
  productIsAvalibleToOrder: 'The product is available to order',
  deliveryTimeDays: 'Delivery time is {days} days from ordering the product',
  itemIsAvalibleContactRepresentative: 'The item is available to order. Please contact your sales representative.',
  availableOnRequest: 'Available on request',
  requestPresentation: 'Request a presentation',
  administrator: 'Administrator',
  howDoYouRateThisProduct: 'How do you rate this product?',
  listIsEmpty: 'List is empty',
  noResultsAccordingToTheGivenParameters: 'No results according to the given parameters',
  termsOfUseIsMandatory: 'The Terms of Use field is mandatory',
  resetPassword: 'Reset password',
  accVerification: 'Account verification',
  verificationLinkHasExpired: 'The verification link has expired. Please contact our administrators: support@eurosan.ba or +387 36 342 220.',
  youHaveJustAddedAnItemToTheCart: 'You have just added an item to the cart:',
  accVerificationInProgress: 'Account verification in progress',
  goToShoppingCart: 'Go to shopping cart',
  manufacturer: 'Manufacturer',
  continueShopping: 'Continue shopping',
  productName: 'Product name',
  preview: 'Preview',
  discount: 'Discount',
  sale: 'SALE',
  quantity: 'Quantity',
  quantity2: 'QUANTITY',
  physicalPersons: 'Physical persons',
  price: 'Price',
  aboutUs: 'About us',
  defaultAddress2: 'Default address',
  newAddress2: 'New address',
  newAddress: '+ New address',
  price2: 'PRICE',
  emailAddress: 'Email address',
  show: 'Show',
  stock: 'Stock',
  yourTotalDebtIs: 'Your total debt is',
  print: 'Print',
  noDataToAccordingData: 'There is no data according to the requested parameters',
  isInStock: 'Is in stock',
  signUpForTheNewsletter: 'Sign up for the newsletter',
  latestInformations: 'Get all the latest information on events, sales and offers.',
  sales: 'Sales',
  subscribe: 'Subscribe',
  phoneNumber: 'Phone number',
  aboutEurosanGroup: 'About Eurosan group',
  category: 'Category',
  jobAtEurosan: 'Job at Eurosan',
  title: 'Title',
  responsibleBusiness: 'Responsible business',
  deleteBank: 'Delete bank',
  deleteBlog: 'Delete blog',
  deleteCompany: 'Delete company',
  deleteCountry: 'Delete country',
  deleteCurrency: 'Delete currency',
  deleteCustomerBankAccount: 'Delete customer bank account',
  deleteProductSale: 'Delete product sale',
  deleteTown: 'Delete town',
  deleteUser: 'Delete user',
  deleteVariationImage: 'Are you sure you want to delete the variation image?',
  highlightedCategories: 'Highlighted',
  newArticles: 'New products',
  priceRange: 'Price range',
  recentlyViewdItems: 'Recently viewed',
  rmaForm: 'Complaints',
  saveArticle: 'Save article',
  saveCategory: 'Save category',
  saveCountry: 'Save country',
  total: 'Total',
  amount: 'Amount',
  topBrands: 'Top brands',
  userArticles: 'Products selected for you',
  viewAll: 'View all',
  viewAllFrom: 'View all from',
  clearShoppingCart: 'Clear cart',
  updateShoppingCart: 'Update cart',
  addToWishlist: 'Add to wishlist',
  tabReviews: 'Reviews',
  writeReview: 'Write your review',
  submitReview: 'Submit review',
  anonymous: 'Anonymous',
  linkedArticles: 'Related products',
  quickPreview: 'Quick preview',
  loginRegisterTitle: 'Login / Create account',
  loginTitle: 'Login',
  loginSubTitle: 'If you already have an account, please log in.',
  loginButton: 'LOGIN',
  registerTitle: 'Request an account',
  registerSubTitle: 'Fill in the required information and our team will contact you shortly to create your user account. Thank you!',
  chooseCountry: 'Choose country',
  chooseTown: 'Choose town',
  registerSectionLoginDataTitle: 'Login information',
  acceptTerms: 'I accept the terms of use',
  registerSubmit: 'Request account',
  repeatOrder: 'Repeat order',
  close: 'Close',
  defaultSort: 'Default sorting',
  sortByRating: 'Sort by rating',
  sortByDateOldest: 'Sort by publish date: oldest to newest',
  sortByDateNewest: 'Sort by publish date: newest to oldest',
  sortByPriceLow: 'Sort by price: low to high',
  sortByPriceHigh: 'Sort by price: high to low',
  pagingResults: 'Showing {fromResults} - {toResults} of {totalItems} results',
  documentName: 'Document name',
  status: 'Status',
  orderNumber: 'Order number',
  orderer: 'Orderer',
  date: 'Date',
  document: 'Document',
  delivery: 'Delivery',
  deliverTo: 'Deliver to',
  savingsByUsingPromoCode: 'Savings using promo code',
  totalAmountWithDelivery: 'Total with delivery',
  youHaveNotPlacedAnorderYet: 'You have not placed an order yet',
  amountWithoutVat: 'Amount without VAT',
  vatAmount: 'VAT amount',
  orderNo: 'Order no.',
  time: 'Time',
  rejectOrd: 'Reject order',
  approveOrd: 'Approve order',
  promoCode: 'Promo code',
  send: 'Send',
  registrationCode: 'Registration code',
  created: 'Created',
  giftCard: 'Gift code',
  vpc: 'VPC',
  tax: 'VAT',
  totalWithVat: 'Total with VAT',
  totalWithoutVat2: 'Total without VAT',
  summary: 'Summary',
  warranty: 'Warranty',
  indeterminate: 'Indeterminate',
  description: 'Description',
  forms: {
    notValid: 'Data entered is not valid!',
    labels: {
      code: 'Code',
      name: 'Name',
      countryName: 'Country name',
      townName: 'Town name',
      title: 'Title',
      description: 'Description',
      bankAccount: 'Bank account',
      address: 'Address',
      country: 'Country',
      abbreviation: 'Abbreviation',
      unit: 'Unit',
      symbol: 'Symbol',
      bank: 'Bank',
      company: 'Company',
      officeNumber: 'Office number',
      catalogNumber: 'Catalog number',
      category: 'Category',
      brand: 'Brand',
      interestsArea: 'Interest ares',
      taxGroup: 'Tax group',
      shortDescription: 'Short description',
      nc: 'NC',
      mpc: 'MPC',
      vpc: 'VPC',
      isVisibleOnWeb: 'Visible on web',
      unitOfMeasure: 'Unit of measure',
      nettoWeight: 'Netto weight',
      videoUrl: 'Video link',
      content: 'Content',
      firstName: 'First name',
      lastName: 'Last name',
      availableValues: 'Available values',
      town: 'Town',
      username: 'Korisničko ime',
      email: 'E-mail adresa',
      articleType: 'Vrsta artikla',
      defaultPrice: 'Zadana cijena',
      fax: 'Faks',
      phone: 'Telefon',
      password: 'Lozinka',
      confirmPassword: 'Ponovi lozinku',
    },
    errors: {
      required: 'Field {field} is required.',
      minLength: 'Min {count} characters.',
      integer: 'Field {field} must be a number.',
      email: 'Field {field} is not valid email address.',
      url: 'Field {field} is nov valid url.',
      sameAs: 'Field {field} i field {field2} do not match.',
      default: 'An error occurred during validation.',
    },
  },
  tables: {
    id: 'ID',
    name: 'Name',
    firstLastName: 'First and last name',
    phone: 'Phone',
    email: 'E-mail',
    username: 'UserName',
    town: 'Town',
  },
};
